import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import moment from "moment";

import { SearchOutlined } from "@ant-design/icons";

import { Table, Input, Button, Popconfirm, Tag } from "antd";
import Highlighter from "react-highlight-words";

import Breadcrumb from "../../components/Breadcrumb";

import CreateForm from "../../components/MainRoles/MainRolesManager/CreateForm";
import UpdateForm from "../../components/MainRoles/MainRolesManager/UpdateForm";

// const data = this.props.api.userGetData;

class MainRolesManager extends Component {
  state = {
    searchText: "",
    searchedColumn: "",
    loading: false,
    visible: false,
    createModalVisible: false,
    updateModalVisible: false,
    updateInitialValue: null,
  };
  async componentDidMount() {
    if (!this.props.api.mainRolesGetData) {
      await this.props.mainRolesGet();
    }
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          // placeholder={`Search ${dataIndex}`}
          placeholder="Search"
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{
            width: 90,
            marginRight: 8,
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    this.setState({ searchText: "" });
  };

  createModalShow = () => {
    this.setState({ createModalVisible: true });
  };

  createModalCancel = () => {
    this.setState({ createModalVisible: false });
  };

  createModalCreate = () => {
    const { form } = this.createModalFormRef.props;
    form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        return;
      }
      // const qqqq = await this.props.userCreate(values);

      if (await this.props.mainRoleCreate(values)) {
        form.resetFields();
        await this.props.mainRolesGet();
        this.setState({ createModalVisible: false });
      }
    });
  };

  createModalFormRefSaveFormRef = (formRef) => {
    this.createModalFormRef = formRef;
  };

  handleEdit = (data) => {
    this.setState({ updateModalVisible: true, updateInitialValue: data });
  };

  updateModalShow = (data) => {
    this.setState({ updateModalVisible: true, updateInitialValue: data });
  };

  updateModalCancel = () => {
    const { form } = this.updateModalFormRef.props;
    form.resetFields();
    this.setState({ updateModalVisible: false, updateInitialValue: null });
  };

  updateModalCreate = () => {
    const { form } = this.updateModalFormRef.props;
    form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        return;
      }
      // const qqqq = await this.props.userCreate(values);

      if (await this.props.mainRoleUpdate(values)) {
        form.resetFields();
        await this.props.mainRolesGet();
        this.setState({ updateModalVisible: false });
      }
    });
  };

  updateModalFormRefSaveFormRef = (formRef) => {
    this.updateModalFormRef = formRef;
  };

  render() {
    const columns = [
      {
        title: "Main Role Name",
        dataIndex: "main_role_name",
        key: "main_role_name",
        fixed: "left",
        width: "200px",
        ...this.getColumnSearchProps("main_role_name"),
        sorter: (a, b) =>
          a.main_role_name
            ? a.main_role_name.localeCompare(b.main_role_name)
            : null,
      },
      {
        title: "ID",
        dataIndex: "_id",
        key: "_id",
        width: "250px",
        ...this.getColumnSearchProps("_id"),
      },

      {
        title: "Created by",
        dataIndex: "create_by",
        key: "create_by",
        width: "200px",
        ...this.getColumnSearchProps("create_by"),
      },
      {
        title: "Created at",
        dataIndex: "create_at",
        key: "create_at",
        width: "200px",
        ...this.getColumnSearchProps("create_at"),
        render: (text) => (
          <span>
            {text ? moment(text).local().format("YYYY-MM-DD HH:mm:ss") : null}
          </span>
        ),
      },
      {
        title: "Updated by",
        dataIndex: "update_by",
        key: "update_by",
        width: "200px",
        ...this.getColumnSearchProps("update_by"),
      },
      {
        title: "Updated at",
        dataIndex: "update_at",
        key: "update_at",
        width: "200px",
        ...this.getColumnSearchProps("update_at"),
        render: (text) => (
          <span>
            {text ? moment(text).local().format("YYYY-MM-DD HH:mm:ss") : null}
          </span>
        ),
      },

      {
        title: "Action",
        dataIndex: "action",
        fixed: "right",
        width: "100px",
        render: (text, record) => (
          <Popconfirm
            title="Sure to edit?"
            onConfirm={() => this.updateModalShow(record)}
          >
            <a href="/#">Edit</a>
          </Popconfirm>
        ),
      },
    ];

    return (
      <div>
        <div className="container_aa">
          <h3>Main Roles Manager</h3>
          <Breadcrumb
            routes={[
              { path: "/", breadcrumbName: "Dashboard" },
              {
                path: "main-roles-manager",
                breadcrumbName: "Main Roles Manager",
              },
            ]}
          />
        </div>

        <div className="container_ab">
          <div className="container_style_1 user_manager">
            <div className="container_style_1_a">
              <Button type="primary" onClick={this.createModalShow}>
                Create Main Role
              </Button>
            </div>
            <div className="container_style_1_b" style={{ width: "100%" }}>
              {this.props.api.mainRolesGetData ? (
                <div className="is_table_3">
                  <Table
                    columns={columns}
                    scroll={{ x: 1350 }}
                    dataSource={this.props.api.mainRolesGetData.data}
                    rowKey="_id"
                  />
                </div>
              ) : null}

              <CreateForm
                wrappedComponentRef={this.createModalFormRefSaveFormRef}
                visible={this.state.createModalVisible}
                onCancel={this.createModalCancel}
                onCreate={this.createModalCreate}
              />

              <UpdateForm
                wrappedComponentRef={this.updateModalFormRefSaveFormRef}
                visible={this.state.updateModalVisible}
                onCancel={this.updateModalCancel}
                onCreate={this.updateModalCreate}
                updateInitialValue={this.state.updateInitialValue}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  mainRolesGet: () => dispatch(actions.mainRolesGet()),

  mainRoleCreate: (data) => dispatch(actions.mainRoleCreate(data)),
  mainRoleUpdate: (data) => dispatch(actions.mainRoleUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainRolesManager);
